import { stepDotClass } from "./mockupStyles";
import { Check } from "lucide-react";

export const HeroMockup = () => (
  <div className="card-soft rounded-2xl overflow-hidden bg-white">
    <div className="px-5 py-3 border-b border-navy-100 flex items-center gap-2 bg-navy-50">
      <span className="w-2.5 h-2.5 rounded-full bg-rose-300" />
      <span className="w-2.5 h-2.5 rounded-full bg-amber-300" />
      <span className="w-2.5 h-2.5 rounded-full bg-emerald-300" />
      <span className="ml-3 text-[11px] font-mono text-navy-500">leaseflow.uk/cases/2024-LE-0042</span>
    </div>
    <div className="p-6">
      <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-emerald-600">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse-soft" /> Active case
      </div>
      <p className="mt-2 font-display text-xl text-navy-900">14 Acacia Avenue, Flat 3 · Lease Extension</p>
      <p className="text-sm text-navy-500">Section 42 statutory · Jane Beaumont (client)</p>

      <div className="mt-6 relative">
        <div className="absolute left-[11px] top-2 bottom-2 w-0.5 bg-navy-100" />
        {[
          { label: "Initial notice served", date: "12 Sep 2024", done: true },
          { label: "Counter-notice received", date: "08 Nov 2024", done: true },
          { label: "Valuation agreed", date: "21 Jan 2025", done: true, current: true },
          { label: "Draft transfer", date: "Mid Feb 2025", done: false },
          { label: "Completion", date: "Mar 2025", done: false },
        ].map((s) => (
          <div key={s.label} className="relative flex items-start gap-4 py-2.5">
            <span className={`relative z-10 w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${stepDotClass(s)}`}>
              {s.done && !s.current && <Check className="w-3 h-3 text-emerald-600" strokeWidth={3} />}
              {s.current && <span className="w-2 h-2 rounded-full bg-white" />}
            </span>
            <div className="flex-1 min-w-0">
              <p className={`text-sm ${s.done || s.current ? "text-navy-900" : "text-navy-400"}`}>{s.label}</p>
              <p className="text-xs font-mono text-navy-400">{s.date}</p>
            </div>
            {s.current && (
              <span className="text-[10px] font-mono uppercase tracking-widest px-2 py-1 bg-emerald-50 text-emerald-700 rounded-full border border-emerald-200">
                Current
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  </div>
);
